// extracted by mini-css-extract-plugin
module.exports = {"modal":"TakeOwnershipButton_modal__2qItE"};